export const UserType = {
	SUPER_ADMIN: "super_admin",
	COMPANY_ADMIN: "company_admin",
	BRANCH_ADMIN: "branch_admin",
	BRANCH_USER: "business_user",
	PHOTOGRAPHER: "photographer",
	USER: "user",
};
